/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "../BaseCom";
import Checkout2 from "./Checkout2";
import L from "../Lang";

export default class Checkout2Modal extends BaseCom {
    render() {
        if (!this.props.show) return;
        return (
            <Modal show={this.props.show} onHide={this.props.onHide} size="lg">
                <Modal.Header closeButton><L>Checkout</L></Modal.Header>
                <Modal.Body>
                    <Checkout2 currentItem={this.props.currentItem} onSuccess={this.props.onSuccess} />
                </Modal.Body>
            </Modal>
        )
    }
}